import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "utils/ui";

interface Props {
  term: string | null;
  onSearch: (term: string | null) => void;
  className?: string;
  placeholder?: string;
  debounceDelay?: number;
}

const SearchInput = ({ term = "", className, onSearch, placeholder, debounceDelay = 300 }: Props) => {
  const { t } = useTranslation("translation");
  const [searchValue, setSearchValue] = useState(term ?? "");
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    debounceTimerRef.current = setTimeout(() => {
      onSearch(searchValue.trim() === "" ? null : searchValue);
    }, debounceDelay);

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, debounceDelay]);

  useEffect(() => {
    setSearchValue(term ?? "");
  }, [term]);

  const handleOnSearch = (fromTerm: string) => {
    setSearchValue(fromTerm);
  };
  return (
    <div className={cn("text-color-primary min-w-0 flex-1", className)}>
      <label htmlFor="offer-search" className="sr-only">
        {t("common.search.label")}
      </label>
      <div className="relative rounded-md">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <MagnifyingGlassIcon className="size-5 text-gray-400" aria-hidden="true" />
        </div>
        <input
          id="task-offer-search"
          type="search"
          name="pp-search"
          value={searchValue}
          autoComplete="one-time-code"
          onChange={(e) => handleOnSearch(e.target.value)}
          placeholder={placeholder ? placeholder : t("common.search.label")}
          className="text-color-primary w-full rounded-md border-gray-300 pl-10 dark:border-slate-600 dark:bg-slate-700 dark:placeholder:text-slate-400 sm:text-sm"
        />
      </div>
    </div>
  );
};
export default SearchInput;
